import React, { useEffect, useState } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import './CreateProduct.css';
import {
    makeStyles, Paper, Button, CircularProgress, FormControl, FormControlLabel, Radio, RadioGroup, Divider
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import clsx from 'clsx';
import classNames from 'classnames';
import { convertToRaw, EditorState, RichUtils } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { newEvent } from '../Models/ProductsModel';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import CustomAlert from '../CustomAlert';
import CheckUserProvider from '../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { createFranchiseEventsDocument, uploadFranchiseDocument } from '../../Backend/firebase/franchise-events';
import { EntryFeeInputRow } from './EntryFeeInputRow';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
        padding: '20px'
    },
}));

function CreateFranchiseEvents() {
    const { register, handleSubmit, errors, reset } = useForm();
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const [eventDescription, setEventDescription] = useState(() => EditorState.createEmpty());
    const [aboutTheFranchiseEvents, setAboutTheFranchiseEvents] = useState(() => EditorState.createEmpty());
    const [eligibilityCriteriaForFranchise, setEligibilityCriteriaForFranchise] = useState(() => EditorState.createEmpty());
    const [areaRequired, setAreaRequired] = useState(() => EditorState.createEmpty());
    const [targetCities, setTargetCities] = useState(() => EditorState.createEmpty());
    const [minimumInvestment, setMinimumInvestment] = useState(() => EditorState.createEmpty());
    const [whyUs, setWhyUs] = useState(() => EditorState.createEmpty());
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { userData } = CheckUserProvider();

    const onSubmit = async (data) => {
        setIsLoading(true);
        const eventDescriptionValue = convertToRaw(eventDescription.getCurrentContent());
        const aboutTheFranchiseEventsValue = convertToRaw(aboutTheFranchiseEvents.getCurrentContent());
        const eligibilityCriteriaForFranchiseValue = convertToRaw(eligibilityCriteriaForFranchise.getCurrentContent());
        const areaRequiredValue = convertToRaw(areaRequired.getCurrentContent());
        const targetCitiesValue = convertToRaw(targetCities.getCurrentContent());
        const minimumInvestmentValue = convertToRaw(minimumInvestment.getCurrentContent());
        const whyUsValue = convertToRaw(whyUs.getCurrentContent());
        // if (eventDescription.getCurrentContent().hasText()) {
            newEvent.userId = userData.uid;
            newEvent.eventName = data.eventName;
            newEvent.eventType = data.eventType;
            newEvent.eventCategory = "Franchise Events";
            newEvent.location = data.location;
            newEvent.city = data.city;
            newEvent.phone = data.phone;
            newEvent.email = data.email;
            newEvent.yearOfEstablishment = data.yearOfEstablishment;
            newEvent.certification = data.certification;
            newEvent.otherUnites = data.otherUnites;
            newEvent.eventImage = null
            newEvent.eventDescription = String(JSON.stringify(eventDescriptionValue));
            newEvent.aboutTheFranchiseEvents = String(JSON.stringify(aboutTheFranchiseEventsValue));
            newEvent.eligibilityCriteriaForFranchise = String(JSON.stringify(eligibilityCriteriaForFranchiseValue));
            newEvent.areaRequired = String(JSON.stringify(areaRequiredValue));
            newEvent.targetCities = String(JSON.stringify(targetCitiesValue));
            newEvent.minimumInvestment = String(JSON.stringify(minimumInvestmentValue));
            newEvent.whyUs = String(JSON.stringify(whyUsValue));
            newEvent.eventStatus = 'New';
            if (data.franchiseProductListDocument.length > 0) {
                var productListPath = null;
                productListPath = `Franchise/${userData.uid
                    }/${data.eventName}_List.${data.franchiseProductListDocument[0].name.split('.').pop()}`
                await uploadFranchiseDocument(productListPath, data.franchiseProductListDocument[0])
                newEvent.franchiseProductListDocumentPath = productListPath
            }
            if (data.franchiseAwardsAndCertificatesDocumentPath.length > 0) {
                var awardsAndCertificates = null;
                awardsAndCertificates = `Franchise/${userData.uid
                    }/${data.eventName}_Awards.${data.franchiseAwardsAndCertificatesDocumentPath[0].name.split('.').pop()}`
                await uploadFranchiseDocument(awardsAndCertificates, data.franchiseAwardsAndCertificatesDocumentPath[0])
                newEvent.franchiseAwardsAndCertificatesDocumentPath = awardsAndCertificates
            }
            try {
                var event = createFranchiseEventsDocument(newEvent);
                if (event) {
                    setNotificationMessage('Franchise created successfully.');
                    setOpenNotify(true);
                    setAlertType('success');
                    reset();
                    setEventDescription(EditorState.createEmpty());
                    setIsLoading(false);
                    setTimeout(routeToPages, 2000);
                } else {
                    setNotificationMessage('Something went wrong, Please try again later!!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsLoading(false);
                    history.push('/retailer/create-franchise-events');
                }
            }  catch (error) {
                console.error(error);
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
                history.push('/retailer/create-franchise-events');
            }
        // } else {
        //     setNotificationMessage("Please enter event description!");
        //     setOpenNotify(true);
        //     setAlertType('error');
        //     setIsLoading(false);
        // }
    };

    const routeToPages = () => {
        window.location.pathname = '/retailer/franchise-events';
    }

    const onEditorStateChange = (editorState) => {
        setEventDescription(editorState);
    };

    const onEditorAboutTheFranchiseEventsStateChange = (editorState) => {
        setAboutTheFranchiseEvents(editorState);
    };

    const onEditorEligibilityCriteriaForFranchiseStateChange = (editorState) => {
        setEligibilityCriteriaForFranchise(editorState);
    };

    const onEditorAreaRequiredStateChange = (editorState) => {
        setAreaRequired(editorState);
    };

    const onEditorTargetCitiesStateChange = (editorState) => {
        setTargetCities(editorState);
    };

    const onEditorMinimumInvestmentStateChange = (editorState) => {
        setMinimumInvestment(editorState);
    };

    const onEditorWhyUsStateChange = (editorState) => {
        setWhyUs(editorState);
    };

    return (
        <>
            <div className="createProduct mt-2">
                <Helmet>
                    <meta name="description" content="Creating New event Event." />
                    <title>Create New Franchise | Kaipsool Franchisetech</title>
                </Helmet>
                <Paper className={fixedHeightPaper}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <div className="col-md-12 mb-2">
                                Name of the Franchise <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.eventName })}
                                    name="eventName" autoComplete="none"
                                    ref={register({ required: 'Please enter Name of the Franchise!' })} />
                                <small className="form-text text-danger">{errors.eventName && errors.eventName.message}</small>
                            </div>
                            <div className="col-md-12 mb-2">
                                Type of Franchise <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.eventType })}
                                    name="eventType" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Franchise Type!' })} />
                            </div>
                            <div className="col-md-8 mb-2">
                                Address <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.location })}
                                    name="location" autoComplete="none"
                                    ref={register({ required: 'Please enter Location!' })} />
                                <small className="form-text text-danger">{errors.location && errors.location.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                City <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.city })}
                                    name="city" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter City!' })} />
                            </div>
                            <div className="col-md-4 mb-2">
                                Contact Number <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.phone })}
                                    name="phone" autoComplete="none"
                                    ref={register({ required: 'Please enter Contact Number!' })} />
                                <small className="form-text text-danger">{errors.phone && errors.phone.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Email <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.email })}
                                    name="email" autoComplete="none"
                                    ref={register({ required: 'Please enter Email!' })} />
                                <small className="form-text text-danger">{errors.email && errors.email.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Year of Establishment <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.yearOfEstablishment })}
                                    name="yearOfEstablishment" autoComplete="none"
                                    ref={register({ required: 'Please enter Year Of Establishment!' })} />
                                <small className="form-text text-danger">{errors.yearOfEstablishment && errors.yearOfEstablishment.message}</small>
                            </div>
                            <div className="col-md-12 mb-2">
                                Certification <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.certification })}
                                    name="certification"
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Certification!' })}
                                />
                                <small className="form-text text-danger">{errors.certification && errors.certification.message}</small>
                            </div>
                            <div className="col-md-12 mb-2">
                                Other Unites
                                <input type="text" className={classNames("form-control registerEmp__textbox")}
                                    name="otherUnites"
                                    autoComplete="none"
                                    ref={register}
                                />
                            </div>
                            <div className="col-md-6 mb-2">
                                <div className="form-group">
                                <label className="login__textboxLabel">
                                    Upload Product List<small>(Accept pdf only)</small>
                                </label>
                                <input
                                    type="file"
                                    className={classNames('form-control registerEmp__textbox')}
                                    name="franchiseProductListDocument"
                                    placeholder="Your Product List"
                                    accept=".pdf"
                                    ref={register}
                                    onChange={(e)=> { }}
                                />
                                </div>
                            </div>
                            <div className="col-md-6 mb-2">
                                <div className="form-group">
                                <label className="login__textboxLabel">
                                    Awards & Certificates<small>(Accept pdf only)</small>
                                </label>
                                <input
                                    type="file"
                                    className={classNames('form-control registerEmp__textbox')}
                                    name="franchiseAwardsAndCertificatesDocumentPath"
                                    placeholder="Your Awards & Certificates"
                                    accept=".pdf"
                                    ref={register}
                                    onChange={(e)=> {  }}
                                />
                                </div>
                            </div>
                            <h3 className="mt-4 border__bottom">Descriptions</h3>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>About the Franchise</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={aboutTheFranchiseEvents} onEditorStateChange={onEditorAboutTheFranchiseEventsStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Eligibility criteria for franchise</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={eligibilityCriteriaForFranchise} onEditorStateChange={onEditorEligibilityCriteriaForFranchiseStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Area Required</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={areaRequired} onEditorStateChange={onEditorAreaRequiredStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Target cities</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={targetCities} onEditorStateChange={onEditorTargetCitiesStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Minimum Investment</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={minimumInvestment} onEditorStateChange={onEditorMinimumInvestmentStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Why Us</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={whyUs} onEditorStateChange={onEditorWhyUsStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mt-4 mb-2 mr-3">
                                <b>Other Details</b>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={eventDescription} onEditorStateChange={onEditorStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-sm-12 text-right mt-2">
                                <div className="d-flex justify-content-center">
                                    <div className="p-2">
                                        <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                            {isLoading ? <CircularProgress size={18} /> : 'Create Farnchise'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Paper>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} verticalPosition="bottom" horizontalPosition="center" />
        </>
    )
}

export default CreateFranchiseEvents

